import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import { InCRMCell } from "app/pages/sales-intelligence/modules/crm-integration/components/cells/InCRMCell/InCRMCell";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import leadsSearchTrackingService from "app/pages/sales-intelligence/modules/leads-search/services/tracking/trackingService";

type Props<R extends LeadsSearchRow> = {
    record: R;
    value?: string;
    integrationProvider: CrmIntegrationProvider;
};

const InCrmCellContainer = <R extends LeadsSearchRow = LeadsSearchRow>({
    value,
    integrationProvider,
    record,
}: Props<R>) => {
    return (
        <InCRMCell
            value={value}
            type={integrationProvider}
            onCellClick={() => leadsSearchTrackingService.trackInCRMCellClick(integrationProvider, record.company)}
            onUpgradeClick={() => leadsSearchTrackingService.trackInCRMHookClick()}
        />
    );
};

export default InCrmCellContainer;
